interface Variable {
    id: number,
    itsId: number,
    uid: string,
    name: string,
    tags: string,
    hookId: string,
    notes: null,
    source: null,
    isChoice: boolean,
    choices: [
        {
            choice: string,
            value: number
        },
        {
            choice: string,
            value: number
        }
    ],
    value: number,
    originalValue: number,
    displayValue: string
}

export interface ValuePropositionAPI {
    setBatchVariableNotes(hookId: string, notes: string): void;
    setBatchVariableValue(hookId: string, value: number | string | boolean): void;
    commitVariableMetadataBatch(): void;
    setBatchVariableValueCommit(): void;
    getVariablesByTag(tag: string): Variable[];
    getVariableByHookId(hookId: string): { value: number, uid: string };
    getValueDriversByHookId(hookId: string): {value: number, uid: string}
    registerValuePropositionChangedEvent(eventType: string, callback: () => void): void;
    setVariableValue(variableId: string, value: number): void;
    setVariableValueWithSource(variableId: string, value: number, source: string): void;
    fireModelEvent(event: string): void;
    refreshMeta(): void;
    getCustomData(): any;
    setCustomData(dataId: string): any;
    getValueModelId(): string;
    getUVPId(): string,
    getValuePropId(): string,
    registerUIEvent(event: string, handler: any): void;
    getCustomerName(): string;
    fireUIEvent(type: string, payload: any): void;
    render(): void;
    refresh(): void;
    isUnchanged(): boolean;
    isPreview(): boolean;
}


export function getValuePropositionAPI(): ValuePropositionAPI | null {

    if (window['ValuePropositionAPI']) {
        return window['ValuePropositionAPI'] as ValuePropositionAPI
    }

    return null
}
